import { FlexColumn, FlexRow, LabeledData, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import { HeadingXSmall } from 'baseui/typography';
import { useStyles } from '../../../../hooks/useStyles';
import { FleetDriverDetail } from '../../../../types/drivers';
import { getDriverFullName } from '../../../../utils/drivers';
import FleetDriverAvatar from './FleetDriverAvatar';

type Props = {
  editDriver: (edit: boolean) => void;
  driver: FleetDriverDetail;
};

function FleetDriverData({ editDriver, driver }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const labelWidth = '140px';

  return (
    <>
      <FlexRow
        centered
        classNames={css({ justifyContent: 'space-between' })}
      >
        <HeadingXSmall margin={0}>{getDriverFullName(driver)}</HeadingXSmall>
        <StyledButton
          onClick={() => editDriver(true)}
          endEnhancer={
            <MaterialIcon
              name="edit"
              size={theme.sizing.scale600}
              color={theme.colors.contentInversePrimary}
            />
          }
        >
          Editar
        </StyledButton>
      </FlexRow>
      <FlexColumn gap={theme.sizing.scale600}>
        <FleetDriverAvatar
          lastName={driver.lastName}
          name={driver.name}
          photo={driver.photo}
          size="130px"
        />
        <FlexColumn gap={theme.sizing.scale300}>
          <LabeledData
            label="Nombre(s):"
            content={driver.name || '-'}
            inline={false}
            maxLines={5}
            labelWidth={labelWidth}
          />
          <LabeledData
            label="Apellido(s):"
            content={driver.lastName || '-'}
            inline={false}
            maxLines={5}
            labelWidth={labelWidth}
          />
          <LabeledData
            label="Teléfono:"
            content={driver.phone || '-'}
            inline={false}
            maxLines={5}
            labelWidth={labelWidth}
          />
          <LabeledData
            label="Correo electrónico:"
            content={driver.email || '-'}
            inline={false}
            maxLines={5}
            labelWidth={labelWidth}
          />
          <LabeledData
            label="Número de licencia:"
            content={driver.licenseNumber || '-'}
            inline={false}
            maxLines={5}
            labelWidth={labelWidth}
          />
          <LabeledData
            label="Expiración licencia:"
            content={driver.licenseExpiry || '-'}
            inline={false}
            maxLines={5}
            labelWidth={labelWidth}
          />
        </FlexColumn>
      </FlexColumn>
    </>
  );
}

export default FleetDriverData;
